// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-follow[data-v-cbcb20c2]{box-sizing:border-box;width:64px;height:26px;font-size:12px;display:flex;align-items:center;justify-content:center;color:#386ff2;background:#fff;border-radius:4px;border:1px solid #386ff2;cursor:pointer;transition:all .3s ease-in-out}.followed[data-v-cbcb20c2]{background:#98bbe8!important;color:#fff;border:1px solid #98bbe8}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
